import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useLanguage } from '../../context/LanguageContext';

const TeamPage = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const teamMembers = [
    {
      name: 'Mamadou Diallo',
      title: 'Fondateur & Directeur Général',
      description: 'Consultant senior en gouvernance publique et transformation institutionnelle, avec plus de 15 ans d\'expérience sur des projets d\'État en Afrique et en Europe.',
      photo: 'https://public.readdy.ai/ai/img_res/b61327b41591da918dac4bb5e6ba7b4c.jpg',
    },
    {
      name: 'Ibrahim Koné',
      title: 'Expert en Transformation Digitale',
      description: 'Spécialiste en modernisation des systèmes d\'information publics, il accompagne les institutions dans leur transition numérique avec une approche centrée sur l\'humain.',
      photo: 'https://readdy.ai/api/search-image?query=professional%20african%20male%20consultant%20portrait%2C%20warm%20beige%20background%2C%20friendly%20expression%2C%20business%20casual%20attire%2C%20soft%20natural%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team002&orientation=squarish',
    },
    {
      name: 'Aïssatou Bah',
      title: 'Experte en Gouvernance & Finances Publiques',
      description: 'Ancienne conseillère auprès de ministères des finances, elle apporte une expertise pointue en gestion budgétaire et en réforme des politiques publiques.',
      photo: 'https://readdy.ai/api/search-image?query=professional%20african%20female%20executive%20portrait%2C%20warm%20cream%20background%2C%20confident%20professional%20smile%2C%20elegant%20business%20attire%2C%20soft%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team003&orientation=squarish',
    },
    {
      name: 'Laurent Boin',
      title: 'Expert en Systèmes Décisionnels',
      description: 'Architecte de solutions analytiques pour le secteur public, il aide les décideurs à exploiter la donnée pour piloter des politiques publiques efficaces.',
      photo: 'https://readdy.ai/api/search-image?query=professional%20european%20male%20consultant%20portrait%2C%20warm%20neutral%20background%2C%20thoughtful%20expression%2C%20business%20attire%2C%20soft%20natural%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team004&orientation=squarish',
    },
    {
      name: 'Ghislain Medou',
      title: 'Expert en Automatisation & Processus',
      description: 'Spécialiste en optimisation des processus administratifs, il conçoit des solutions qui simplifient le travail des agents publics et améliorent le service aux citoyens.',
      photo: 'https://readdy.ai/api/search-image?query=professional%20african%20male%20expert%20portrait%2C%20warm%20beige%20background%2C%20approachable%20smile%2C%20smart%20casual%20business%20attire%2C%20soft%20studio%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team005&orientation=squarish',
    },
    {
      name: 'Philippe Jean',
      title: 'Expert en Gestion Budgétaire',
      description: 'Éditeur du progiciel PHEB, il accompagne les institutions publiques dans la modernisation de leur gestion financière et comptable depuis plus de 10 ans.',
      photo: 'https://readdy.ai/api/search-image?query=professional%20european%20male%20senior%20consultant%20portrait%2C%20warm%20cream%20background%2C%20professional%20expression%2C%20business%20attire%2C%20soft%20natural%20lighting%2C%20high%20quality%20headshot%20photography&width=300&height=300&seq=team006&orientation=squarish',
    },
  ];

  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Engagement humain',
      description: 'Nous plaçons les personnes au cœur de chaque mission — agents publics, citoyens, partenaires.',
    },
    {
      icon: 'ri-global-line',
      title: 'Ancrage africain',
      description: 'Une expertise forgée sur le terrain, dans plus de 8 pays africains, avec une compréhension profonde des réalités locales.',
    },
    {
      icon: 'ri-seedling-line',
      title: 'Transfert de compétences',
      description: 'Chaque mission est une opportunité de renforcer les capacités locales et de construire une autonomie durable.',
    },
    {
      icon: 'ri-handshake-line',
      title: 'Partenariat de confiance',
      description: 'Nous construisons des relations de long terme fondées sur la transparence, l\'écoute et la co-construction.',
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FAFAFA', fontFamily: 'Lato, sans-serif' }}>
      <Header />

      {/* Hero Section */}
      <section className="relative bg-[#0B1A36] min-h-[320px] flex items-end justify-center pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {t('team.hero.title')}
          </h1>
          <p className="text-xl md:text-2xl max-w-4xl mx-auto text-gray-200 leading-relaxed">
            {t('team.hero.subtitle')}
          </p>
        </div>
      </section>

      {/* Gold Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      {/* Large Quote */}
      <section className="py-20 px-4" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-double-quotes-l text-5xl text-[#D4AF37]"></i>
          </div>
          <blockquote className="text-2xl md:text-3xl font-light text-[#1B2A4A] leading-relaxed italic">
            Nous ne livrons pas seulement des projets —{' '}
            <span className="font-semibold not-italic">nous transférons les compétences</span>{' '}
            et construisons un changement durable.
          </blockquote>
          <div className="mt-8 w-16 h-1 bg-[#D4AF37] mx-auto rounded-full" />
        </div>
      </section>

      {/* Gold Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      {/* Team Members */}
      <section className="py-20 px-4" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-4">
              Notre équipe
            </h2>
            <div className="w-16 h-1 bg-[#D4AF37] mx-auto rounded-full mt-4" />
            <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
              Des consultants et experts seniors, engagés pour un impact réel et durable.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-28 h-28 rounded-full overflow-hidden mb-6 ring-4 ring-[#D4AF37]/30 bg-[#1B2A4A] flex items-center justify-center flex-shrink-0">
                  <span className="text-3xl font-bold text-[#D4AF37]">
                    {member.name.split(' ').map((n: string) => n[0]).join('')}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1B2A4A] mb-1">{member.name}</h3>
                <p className="text-[#D4AF37] font-semibold text-sm mb-4">{member.title}</p>
                <p className="text-gray-600 text-sm leading-relaxed">{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      {/* Values Section */}
      <section className="py-20 px-4" style={{ backgroundColor: '#FAFAFA' }}>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-4">
              Ce qui nous unit
            </h2>
            <div className="w-16 h-1 bg-[#D4AF37] mx-auto rounded-full mt-4" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-5 rounded-full bg-[#D4AF37]/10">
                  <i className={`${value.icon} text-2xl text-[#D4AF37]`}></i>
                </div>
                <h3 className="text-lg font-bold text-[#1B2A4A] mb-3">{value.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold Divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      {/* Join Us — Navy Closing Section */}
      <section className="py-24 px-4 bg-[#1B2A4A]">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Rejoindre l'équipe
          </h2>
          <div className="w-16 h-1 bg-[#D4AF37] mx-auto rounded-full mb-8" />
          <p className="text-lg text-gray-300 leading-relaxed mb-10">
            Vous êtes consultant, développeur ou expert sectoriel ?{' '}
            <span className="text-white font-medium">Parlons-nous.</span>
          </p>
          <button
            onClick={() => navigate('/contact')}
            className="inline-block bg-[#D4AF37] text-[#1B2A4A] px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#B8941F] transition-colors cursor-pointer whitespace-nowrap"
          >
            Nous écrire
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TeamPage;
